/** Blank defaults for Platform Admin → Add Provider (OpenAI Compatible only). */

export const ADD_PROVIDER_FORM_INITIAL_VALUES = {
  display_name: '',
  provider_key: '',
  base_url: '',
} as const

export function blankAddProviderFormValues() {
  return { ...ADD_PROVIDER_FORM_INITIAL_VALUES }
}
